module.exports = __webpack_public_path__ + "0644abe7e04d2b30f0652faf4a0353d1.pdf";